import { TWITTER_LABEL } from '@dtx-company/true-common/src/constants/labels'

export const SOCIAL_MEDIA_LINKS = [
  {
    alt: 'Navigate to LinkedIn',
    iconUrl: '/icons/linkedin-filled.svg',
    url: 'https://www.linkedin.com/company/flowcode-qr/mycompany/'
  },
  {
    alt: 'Navigate to Instagram',
    iconUrl: '/icons/instagram-outline-white.svg',
    url: 'https://www.instagram.com/getflowcode/'
  },
  {
    alt: 'Navigate to Facebook',
    iconUrl: '/icons/facebook-outline.svg',
    url: 'https://www.facebook.com/GetFlowcode/'
  },
  {
    alt: `Navigate to ${TWITTER_LABEL}`,
    iconUrl: '/icons/social-media/twitter-white.svg',
    url: 'https://x.com/Flowcode'
  },
  {
    alt: 'TikTok Logo',
    iconUrl: '/icons/tiktok-filled-white.svg',
    url: 'https://www.tiktok.com/@getflowcode'
  },
  {
    alt: 'Navigate to Youtube',
    iconUrl: '/icons/social-media/youtube-filled-white.svg',
    url: 'https://www.youtube.com/c/getflowcode'
  }
] as const
